import API from './API'
const route = 'group/'

var Group = (function () {
  function group() {}
  // var service = {
  //   'pet':"寵物友善","wheelchair":"可載輪椅","trunk":"小型搬家","non_betel_nut":"無檳榔",
  //   "non_smoking":"無菸車","japanese":"日語","barrier_free":"無障礙車","english":"英語",
  //   "car_within_five_years":"五年新車","power":"接電","wares":"貨物接送","proxy_driver":"代駕",
  //   "suv":"休旅車","business_signing":"企業簽單"
  // }
  var service = {
    1: '寵物友善',
    2: '可載輪椅',
    3: '小型搬家',
    4: '無檳榔',
    5: '無菸車',
    6: '日語',
    7: '英語',
    8: '無障礙車',
    9: '接電',
    10: '五年新車',
    11: '貨物接送',
    12: '代駕',
    13: '休旅車',
    14: '企業簽單',
  }
  group.prototype.getServiceGroups = function () {
    return service
  }
  group.prototype.getDetail = function (id) {
    return API.get(`${route}${id}`)
  }

  group.prototype.create = function (data) {
    return API.post(route, data)
  }

  group.prototype.update = function (id, data) {
    return API.put(`${route}${id}`, data)
  }
  group.prototype.getList = function () {
    return API.get(`${route}list`)
  }
  group.prototype.getSingleDrivers = function () {
    return API.get(`${route}list/no-group-driver`)
  }
  group.prototype.getOptions = function () {
    return API.get(`${route}options`)
  }
  return group
})()
export default Group



// WEBPACK FOOTER //
// ./src/assets/js/libs/Group.js